// extracted by mini-css-extract-plugin
export default {"playerContainer":"audio-player_playerContainer__F2kVk","show":"audio-player_show__TqVBH","hide":"audio-player_hide__VB2UP","playerIcon":"audio-player_playerIcon__Zak+C"};